import { classNames } from "@circle-react/helpers/twMergeWithCN";
import type { CommunityMember } from "@circle-react/types";
import { CourseCardBadge } from "../CourseCardBadge";
import { CourseCardDetails } from "../CourseCardDetails";

export interface CourseCardProps {
  communityMember: CommunityMember;
  course: {
    thumbnail_image_url: string;
  };
}

export const CourseCard = ({ course, communityMember }: CourseCardProps) => {
  const { thumbnail_image_url } = course;

  return (
    <div
      className={classNames(
        "bg-primary hover:shadow-c-card border-input group h-full w-full overflow-hidden rounded-2xl border p-2.5",
      )}
    >
      <div
        className="bg-overlay-dark aspect-video w-full overflow-hidden rounded-md"
        aria-hidden
      >
        <div className="relative">
          <CourseCardBadge course={course} />
        </div>
        {thumbnail_image_url && (
          <img
            loading="lazy"
            src={thumbnail_image_url}
            alt=""
            className="block h-full w-full object-cover"
          />
        )}
      </div>
      <CourseCardDetails course={course} communityMember={communityMember} />
    </div>
  );
};
